import { useContext, useEffect, useMemo } from "react";
import { ProductContext } from "../context/product";
import classNames from "../helpers/classNames";
import useGetProduct from "../hooks/useGetProduct";

const ProductPreview = () => {
  const { activeProduct, setActiveProduct } = useContext(ProductContext);
  const { isSuccess, data } = useGetProduct();

  useEffect(() => {
    if (isSuccess && data) {
      setActiveProduct(data.variantOptions[0].code);
    }
  }, [isSuccess, data, setActiveProduct]);

  const activeVariantData = useMemo(() => {
    return data?.variantOptions.find(
      (variant) => variant.code === activeProduct
    );
  }, [data?.variantOptions, activeProduct]);

  if (!isSuccess || !data) {
    return null;
  }

  return (
    <div>
      {/* Image */}
      <img
        src={activeVariantData?.mediumImageURL}
        alt={activeVariantData?.shortName}
        className="w-full"
      />

      {/* Switcher */}
      <div className="flex justify-center space-x-2 pt-3 pb-8">
        {data.variantOptions.length > 1
          ? data.variantOptions.map((variant) => (
              <div
                key={variant.code}
                onClick={() => setActiveProduct(variant.code)}
                className={classNames(
                  activeProduct === variant.code
                    ? "border-2 border-black border-solid"
                    : "border-0",
                  "w-8 h-8 rounded-full cursor-pointer overflow-hidden p-0.5"
                )}
              >
                <div
                  className="w-full h-full rounded-full"
                  style={{
                    backgroundColor: variant.colour?.hexadecimalCodes ?? "#000",
                  }}
                />
              </div>
            ))
          : null}
      </div>

      {/* Description */}
      <div>
        <h4 className="text-lg text-gray-900 uppercase tracking-wider font-bold">
          {activeVariantData?.shortName}
        </h4>
        <p className="text-lg text-gray-900">
          {activeVariantData?.colour?.description ?? ""}
        </p>
      </div>
    </div>
  );
};

export default ProductPreview;
